
<div class="app-margin">
    <div>
        <m-incident-app-bar />
        <div style="position: relative; padding-left: 75px">
            <c-inc-todos />

            <v-row class="no-frame">
                <v-col class="col-12 no-frame bottom-line"></v-col>
            </v-row>
        </div>
    </div>
</div>
